import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { RiDashboardHorizontalLine } from 'react-icons/ri'; 
import { MdOutlineBusinessCenter, MdOutlineSettings, MdOutlineShare, MdScreenSearchDesktop } from "react-icons/md";
import { FaRegCircleUser } from "react-icons/fa6";
import { LuTags } from "react-icons/lu";
import { IoInformationCircleOutline } from "react-icons/io5";
import { FaRegFileAlt } from 'react-icons/fa';

//* menuItems & subMenu
const menuItems = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        icon: <RiDashboardHorizontalLine className="me-2 fs-5" />,
        path: '/dashboard',
    },
    {
        id: 'vendors',
        title: 'Vendors',
        icon: <FaRegCircleUser className="me-2 fs-6" />,
        path: '/vendors/all',
    },
    {
        id: 'quotation',
        title: 'Quotations',
        icon: <FaRegFileAlt className="me-2 fs-6" />,
        path: '/quotation',
        subMenu: [
            { title: 'Mobile Bar', path: '/quotation/mobile-bar-quotation' },
            { title: 'Caterer', path: '/quotation/caterer-quotation' },
        ],
    },
    // {
    //     id: 'service',
    //     title: 'Services',
    //     icon: <MdOutlineBusinessCenter className="me-2 fs-5" />,
    //     path: '/service/all-service',
    // },
    // {
    //     id: 'tag',
    //     title: 'Tags',
    //     icon: <LuTags className="me-2 fs-5" />,
    //     path: '/tag/all-tag',
    // },
    {
        id: 'information',
        title: 'Information',
        icon: <IoInformationCircleOutline className="me-2 fs-5" />,
        path: '/information/all-information',
    },
    {
        id: 'social_media',
        title: 'Social Media',
        icon: <MdOutlineShare className="me-2 fs-6" />,
        path: '/social-media/all-social',
    },
    {
        id: 'seo',
        title: 'SEO',
        icon: <MdScreenSearchDesktop className="me-2 fs-6" />,
        path: '/seo/all-seo',
    },
    {
        id: 'site_setting',
        title: 'Site Setting',
        icon: <MdOutlineSettings className="me-2 fs-5" />,
        path: '/site/setting',
    },
    {
        id: 'profile',
        title: 'Profile',
        icon: <RiDashboardHorizontalLine className="me-2 fs-5" />,
        path: '/profile/view',
    },
    {
        id: 'password',
        title: 'password',
        icon: <RiDashboardHorizontalLine className="me-2 fs-5" />,
        path: '/password/change',
    },
];

function Sidebar({ isSidebarVisible }) {
    const location = useLocation();
    const [openMenus, setOpenMenus] = useState([]);

    const isActive = (path) => location.pathname.startsWith(path);

    const handleClick = (id) => {
        setOpenMenus((prev) =>
            prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
        );
    };

    useEffect(() => {
        const activeMenu = menuItems.find((item) =>
            item.subMenu?.some((subItem) => isActive(subItem.path))
        );
        if (activeMenu) {
            setOpenMenus((prev) => [...prev, activeMenu.id]);
        }
    }, [location.pathname]);

    return (
        <div className={`vertical-menu ${isSidebarVisible ? 'vertical-collpsed' : ''} mm-active`}>
            <div data-simplebar="init" className="h-100 mm-show">
                <div className="simplebar-wrapper" style={{ margin: 0 }}>
                    <div className="simplebar-content-wrapper" style={{ height: '100%', overflow: 'hidden' }}>
                        <div className="simplebar-content" style={{ padding: 0 }}>
                            <div id="sidebar-menu" className="mm-active">
                                <ul className="metismenu list-unstyled mm-show" id="side-menu">
                                    <li className="menu-title">Menu</li>
                                    {menuItems.map(({ id, title, icon, path, subMenu }, index) => {
                                        //* hide the last two item
                                        if (index >= menuItems.length - 2) {
                                            return null;
                                        }

                                        const isMainActive = isActive(path) || subMenu?.some((subItem) => isActive(subItem.path));

                                        return (
                                            <li key={id} className={`${isMainActive ? 'mm-active' : ''}`}>
                                                <Link
                                                    to={path}
                                                    className={`waves-effect custom-link ${subMenu?.length > 0 ? 'has-arrow' : ''}`}
                                                    onClick={subMenu?.length > 0 ? (e) => { e.preventDefault(); handleClick(id); } : null}
                                                >
                                                    {icon}
                                                    <span>{title}</span>
                                                </Link>
                                                {subMenu?.length > 0 && (
                                                    <ul className={`sub-menu mm-collapse ${openMenus.includes(id) ? 'mm-show' : ''}`}>
                                                        {subMenu.map((subItem) => (
                                                            <li key={subItem.path} className={isActive(subItem.path) ? 'sub-active' : ''}>
                                                                <Link to={subItem.path}>{subItem.title}</Link>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}
                                            </li>
                                        );
                                    })}

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Sidebar;